import React, { Fragment, useState, ChangeEvent } from "react";
import { Dialog, DialogTitle, DialogContentText, DialogActions, Button, DialogContent, FormControlLabel, Checkbox } from "@material-ui/core";
import { Delete as DeleteIcon } from "@material-ui/icons";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../reducers";
import { setToastMsg } from "../../actions";
import { thunkDeleteTorrents } from "../../thunks";
import LoadingButton from "../Shared/LoadingButton";


export default function Delete() {
  const selected = useSelector((state: RootState) => state.torrent.selected);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const handleOpen = () => {
    if (selected.length === 0) {
      dispatch(setToastMsg('No torrent is selected', 'error'));
    } else {
      setOpen(true);
    }
  }

  const [deleteFiles, setDeleteFile] = useState(true);
  const handleDeleteFileChange = (e: ChangeEvent<HTMLInputElement>) => setDeleteFile(e.target.checked);

  const handleDeletion = () => {
    dispatch(thunkDeleteTorrents(selected, deleteFiles, true));
    handleClose();
  }

  const pending = useSelector((state: RootState) => state.deleting.pending);

  return (
    <Fragment>
      <LoadingButton pending={pending} color="inherit" onClick={handleOpen}>
        <DeleteIcon />
      </LoadingButton>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="deletion-confirmation">Deletion confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure to delete selected torrents?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <FormControlLabel
            control={
              <Checkbox checked={deleteFiles} onChange={handleDeleteFileChange} />
            }
            label="Delete downloaded files"
          />
          <Button onClick={handleDeletion} color="primary">
            Yes, delete those
          </Button>
          <Button onClick={handleClose} color="primary" autoFocus>
            No, cancel it
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  )
}